import contactsApi from './api';

export * from './api';
export default contactsApi;
